import React, { useState, useEffect } from "react";
import { useApi } from "../rootWrapper";
import config from "../apiconfig";
import decodeJWT from "core-module/tiny-functions/decodeJWT";

const sleep = async (ms) =>
  new Promise((resolve) => setTimeout(() => resolve(), ms));

export function useSimpleWebsocket(
  topic,
  callback,
  uri = "me/websocket_mqttsub_token",
  filterData = true,
) {
  const api = useApi();
  const [error, setError] = useState(null);

  useEffect(() => {
    let ws;
    (async function startWebsocket() {
      const res = await api.get("me/websocket_conn_token");

      if (res) {
        const token = res.object?.token;
        if (!token) {
          console.error("No token conn token from api");
          setError("No websocket conn token from api");
          return;
        }

        //ws = new WebSocket(`ws://66.112.179.24:3000/ws?ls=${token}`);
        ws = new WebSocket(`${config.WS.ADDRESS}?ls=${token}`);

        ws.onopen = async function () {
          const res = await api.get(uri, {
            httpGetParameters: {
              topic,
              history: 300,
            },
          });

          const token = res.object?.token;
          if (!token) {
            console.error("No websocket sub token from api");
            setError("No websocket sub token from api");
            return;
          }

          ws.send("jwt " + token);
        };
        ws.onmessage = function (event) {
          if (filterData) {
            const dataSplit = event.data.split(" ");
            if (dataSplit && dataSplit.length === 2 && dataSplit[0] === topic) {
              callback(dataSplit[1]);
            }
          } else {
            callback(event.data);
          }
        };

        ws.onclose = function () {
          // connection closed, discard old websocket and create a new one in 5s
          ws = null;
          // setTimeout(startWebsocket, 5000)
        };

        ws.onerror = function (err) {
          // connection closed, discard old websocket and create a new one in 5s
          ws = null;
          // setTimeout(startWebsocket, 10000)
        };
      }
    })();
    return () => {
      if (ws && ws.readyState === WebSocket.OPEN) {
        ws.send("bye");
      }
    };
  }, []);

  return error;
}
const splitOnFirstSpace = (str) => {
  const index = str.indexOf(" ");
  return index === -1 ? [str, ""] : [str.slice(0, index), str.slice(index + 1)];
};
// returns a function that strips the message recived
function setOnMessage(callback) {
  return function (event) {
    const parts = splitOnFirstSpace(event.data);
    callback(parts[1], parts[0]); //passes data first, then topic
  };
}

export function useWebsocket(uri, callback, httpGetParameters) {
  const api = useApi();
  const [error, setError] = useState(null);
  const [ws, setWs] = useState(null);
  const [lastState, setLastState] = useState({
    uri: null,
    topic: null,
    callback: null,
    waitCount: 0,
  });

  useEffect(() => {
    let internalHoldWs = null;
    (async function startWebsocket() {
      const res = await api.get("me/websocket_conn_token");

      if (!res) {
        console.error("No reponse conn token from api");
        setError("No reponse conn token from api");
        return;
      }

      const token = res.object?.token;

      if (!token) {
        console.error("No token conn token from api");
        setError("No websocket conn token from api");
        return;
      }

      internalHoldWs = new WebSocket(`${config.WS.ADDRESS}?ls=${token}`);
      setWs(internalHoldWs);

      //Initial onmessage set
      internalHoldWs.onmessage = setOnMessage(callback);
    })();
    return () => {
      if (internalHoldWs && internalHoldWs.readyState === WebSocket.OPEN) {
        //Properly close websocket on unmount
        internalHoldWs.send("bye");
      }
    };
  }, []);

  useEffect(() => {
    (async function () {
      if (!ws) {
        return;
      }

      if (ws.readyState !== WebSocket.OPEN) {
        await sleep(10 + 5 ** lastState.waitCount);
        setLastState((prev) => ({
          ...prev,
          waitCount: prev.waitCount + 1,
        }));
        return;
      }

      let wantUpdate = false;
      const newState = { ...lastState };

      if (lastState.uri !== uri) {
        if (lastState.topic != null) {
          ws.send("uns " + lastState.topic);
        }

        const res = await api.get(uri, {
          httpGetParameters,
        });

        const token = res.object?.token;

        if (!token) {
          console.error("No websocket sub token from api");
          setError("No websocket sub token from api");
          return;
        }

        ws.send("jwt " + token);

        const decodedToken = decodeJWT(token);
        window.debugStatsSubToken = token;
        window.debugStatsTopic = decodedToken.topic;

        newState.uri = uri;
        newState.topic = decodedToken.topic;
        wantUpdate = true;
      }

      if (lastState.callback !== callback) {
        ws.onmessage = setOnMessage(callback);
        newState.callback = callback;
        wantUpdate = true;
      }

      if (wantUpdate) {
        setLastState(newState);
      }
    })();
  }, [ws, uri, callback, lastState]);

  return error;
}

export default {};

